import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { UnitModel } from '../models/unit.model';

@Injectable({
  providedIn: 'root',
})
export class UnitMasterService {
  constructor(private http: HttpClient) {}

  lFN_GetUnitList() {
    return this.http.get(`${environment.ROOT_URL}/unit-master`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_SaveUnit(payload: UnitModel) {
    return this.http.post(
      `${environment.ROOT_URL}/unit-master/create-update`,
      payload,  
      {
        withCredentials: false,
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }

  lFN_GetUnitById(unitId: number) {
    return this.http.get(`${environment.ROOT_URL}/unit-master/unit-id/${unitId}`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_ToggleUnitStatus(unitId: number) {
  return this.http.patch(
    `${environment.ROOT_URL}/unit-master/status/${unitId}`,
    {},
    { observe: 'response', responseType: 'json' }
  );
}

}
